<template>
  <div>
    <div class="expoarielview-wrap">
      <img src="../assets/Images/ariel-view-floor-space.jpg" />
    </div>
       <a
        href="#"
        v-on:click.prevent="getPrvLot"
        v-if="startRange != 0"
        class="exhibitorHallleft"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.97"
          height="14.5"
          viewBox="0 0 7.97 14.5"
        >
          <path
            id="left-arrow.svg"
            class="cls-1"
            d="M7930.82,2550.05l-5.85,6.17a0.459,0.459,0,0,0-.16.07,0.95,0.95,0,0,0-.29.73,0.936,0.936,0,0,0,.29.73,0.459,0.459,0,0,0,.16.07l5.85,6.17a1,1,0,0,0,1.4,0,0.99,0.99,0,0,0,0-1.39l-5.21-5.58,5.21-5.58a0.972,0.972,0,0,0,0-1.39A1,1,0,0,0,7930.82,2550.05Z"
            transform="translate(-7924.53 -2549.78)"
          />
        </svg>
        {{$t("expo.prev")}}
      </a>
      <a
        href="#"
        v-on:click.prevent="getNextLot"
        v-if="exhibitorTotalCount > endRange"
        class="exhibitorHallright"
      >
        {{$t("expo.nxt")}}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="14.56"
          viewBox="0 0 8 14.56"
        >
          <path
            id="right-arrow.svg"
            class="cls-1"
            d="M9297.18,2550.03l5.86,6.18c0.06,0.04.12,0.03,0.17,0.07a0.975,0.975,0,0,1,.28.74,1,1,0,0,1-.28.74,1.041,1.041,0,0,1-.16.06l-5.87,6.19a1.014,1.014,0,0,1-1.41,0,0.99,0.99,0,0,1,0-1.39l5.23-5.6-5.23-5.6a0.972,0.972,0,0,1,0-1.39A1.014,1.014,0,0,1,9297.18,2550.03Z"
            transform="translate(-9295.5 -2549.75)"
          />
        </svg>
      </a>
    <div id="parentbooth" v-bind:class="mouseCursorFlg == false ? 'ariel-booths' : 'ariel-booths test' ">
      <ul class="booth-row-1 common-booth-row">
        <li
          :class="
            firstBoothDetails[0] && firstBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a 
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[0].Logo != undefined" :src="firstBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            firstBoothDetails[1] && firstBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a 
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[1].Logo != undefined"  :src="firstBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            firstBoothDetails[2] && firstBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a 
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[2].Logo != undefined"  :src="firstBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            firstBoothDetails[3] && firstBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a id="test"
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[3].Logo != undefined"  :src="firstBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            firstBoothDetails[4] && firstBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a id="test"
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[4].Logo != undefined" :src="firstBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            firstBoothDetails[5] && firstBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a 
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(firstBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo">
                <img v-if="firstBoothDetails[5].Logo != undefined"  :src="firstBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="common-booth-row">
        <li
          :class="
            secondBoothDetails[0] && secondBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[0].Logo != undefined"  :src="secondBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            secondBoothDetails[1] && secondBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[1].Logo != undefined" :src="secondBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            secondBoothDetails[2] && secondBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[2].Logo != undefined" :src="secondBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            secondBoothDetails[3] && secondBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[3].Logo != undefined" :src="secondBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            secondBoothDetails[4] && secondBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[4].Logo != undefined" :src="secondBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>

        <li
          :class="
            secondBoothDetails[5] && secondBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(secondBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2">
                <img v-if="secondBoothDetails[5].Logo != undefined" :src="secondBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="common-booth-row">
        <li
          :class="
            thirdBoothDetails[0] && thirdBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img v-if="thirdBoothDetails[0].Logo != undefined" :src="thirdBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            thirdBoothDetails[1] && thirdBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img  v-if="thirdBoothDetails[1].Logo != undefined" :src="thirdBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            thirdBoothDetails[2] && thirdBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img v-if="thirdBoothDetails[2].Logo != undefined" :src="thirdBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            thirdBoothDetails[3] && thirdBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img v-if="thirdBoothDetails[3].Logo != undefined" :src="thirdBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            thirdBoothDetails[4] && thirdBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img v-if="thirdBoothDetails[4].Logo != undefined" :src="thirdBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            thirdBoothDetails[5] && thirdBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(thirdBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo3">
                <img v-if="thirdBoothDetails[5].Logo != undefined" :src="thirdBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="common-booth-row">
        <li
          :class="
            fourthBoothDetails[0] && fourthBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[0].Logo != undefined" :src="fourthBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fourthBoothDetails[1] && fourthBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[1].Logo != undefined" :src="fourthBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fourthBoothDetails[2] && fourthBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[2].Logo != undefined" :src="fourthBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fourthBoothDetails[3] && fourthBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[3].Logo != undefined" :src="fourthBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fourthBoothDetails[4] && fourthBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[4].Logo != undefined" :src="fourthBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fourthBoothDetails[5] && fourthBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fourthBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo4">
                <img v-if="fourthBoothDetails[5].Logo != undefined" :src="fourthBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="common-booth-row">
        <li
          :class="
            fifthBoothDetails[0] && fifthBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[0].Logo != undefined" :src="fifthBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fifthBoothDetails[1] && fifthBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[1].Logo != undefined" :src="fifthBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fifthBoothDetails[2] && fifthBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[2].Logo != undefined" :src="fifthBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fifthBoothDetails[3] && fifthBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[3].Logo != undefined" :src="fifthBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            fifthBoothDetails[4] && fifthBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[4].Logo != undefined" :src="fifthBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>

        <li
          :class="
            fifthBoothDetails[5] && fifthBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(fifthBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo2 arial-exhibitor-logo5">
                <img v-if="fifthBoothDetails[5].Logo != undefined" :src="fifthBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="common-booth-row">
        <li
          :class="
            sixthBoothDetails[0] && sixthBoothDetails[0].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[0])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[0].Logo != undefined" :src="sixthBoothDetails[0].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            sixthBoothDetails[1] && sixthBoothDetails[1].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[1])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[1].Logo != undefined" :src="sixthBoothDetails[1].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            sixthBoothDetails[2] && sixthBoothDetails[2].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[2])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[2].Logo != undefined" :src="sixthBoothDetails[2].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            sixthBoothDetails[3] && sixthBoothDetails[3].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[3])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[3].Logo != undefined" :src="sixthBoothDetails[3].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            sixthBoothDetails[4] && sixthBoothDetails[4].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[4])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[4].Logo != undefined" :src="sixthBoothDetails[4].Logo" />
              </div>
            </div>
          </a>
        </li>
        <li
          :class="
            sixthBoothDetails[5] && sixthBoothDetails[5].Logo != undefined
              ? ''
              : 'booth-hidden'
          "
        >
          <a
            class="single-booth-new"
            href="#"
            @click.prevent="showtooltip(sixthBoothDetails[5])"
          >
            <div class="ariel-single-booth">
              <img src="../assets/Images/exhibitor-ariel/logo-board.png" />
              <div class="arial-exhibitor-logo arial-exhibitor-logo5">
                <img v-if="sixthBoothDetails[5].Logo != undefined" :src="sixthBoothDetails[5].Logo" />
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scope>
.pl-80 {
  padding-left: 80px;
}

.expoarielview-wrap {
  position: relative;
}

.ariel-booths {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 169px;
  left: 0;
  width: 100%;
}

.ariel-booths ul {
  margin: 0 10px;
  padding: 0;
}

.ariel-booths li {
  display: block;
  list-style: none;
}

.ariel-single-booth {
  height: 94px;
  width: 177px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.ariel-booths ul:first-child {
  transform: skew(-20deg);
}

.ariel-booths ul:nth-child(2) {
  transform: skew(-13deg);
}

.ariel-booths ul:nth-child(3) {
  margin-left: 50px;
  transform: skew(-7deg);
}

.ariel-booths ul:nth-child(3) li {
  transform: skew(7deg);
}

.ariel-booths ul:nth-child(4) {
  margin-right: 48px;
  transform: skew(7deg);
  margin-left: 56px;
}

.ariel-booths ul:nth-child(4) li {
  transform: skew(-7deg);
}

.ariel-booths ul:first-child li {
  transform: skew(20deg);
}

.ariel-booths ul:nth-child(2) li {
  transform: skew(13deg);
}

.ariel-booths ul:nth-child(5){
  transform: skew(20deg);
}

.ariel-booths ul:nth-child(5) li{
  transform: skew(-20deg);
}

.ariel-booths ul:last-child {
  transform: skew(20deg) !important;
}

.ariel-booths ul:last-child li {
  transform: skew(-20deg) !important;
}

.arial-exhibitor-logo {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo2 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo3 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo4 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo2.arial-exhibitor-logo5 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo.arial-exhibitor-logo5 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.ariel-single-booth div img {
  max-height: 100%;
}

.single-booth {
  position: relative;
}

.booth-hidden {
  visibility: hidden;
}

.ariel-booths ul:first-child {
  margin-right: 54px;
}

.ariel-booths.test ul li a .arial-exhibitor-logo:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo2:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo3:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}
.ariel-booths.test ul li a .arial-exhibitor-logo4:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo.arial-exhibitor-logo5:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.custom-tool-tip-right .head-left h3{
font-size: 18px !important;
font-weight: 600;
color: #333;
margin: 0;
cursor: pointer;
}

.custom-tool-tip-right .tool-tip-desc-info-box p{
font-size: 14px !important;
font-weight: 400;
color: #333;
line-height: 18px;
margin: 0 0 20px;
}

.tool-tip-desc-info-box ul li a{display: inline-block;
font-size: 16px;
font-weight: 400;
color: #333;
margin-right: 20px;}

@media only screen and (min-width: 1450px) and (max-width: 1600px) {
  .ariel-booths {
    top: 144px;
  }
  .ariel-single-booth {
    height: 99px;
    width: 177px;
  }
  .arial-exhibitor-logo {
    position: absolute;
    height: 66%;
    width: 88%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 5px;
  }
  .arial-exhibitor-logo2 {
    position: absolute;
    height: 66%;
    width: 88%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 5px;
  }
  .arial-exhibitor-logo3 {
    position: absolute;
    height: 66%;
    width: 88%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 5px;
  }
  .arial-exhibitor-logo4 {
    position: absolute;
    height: 66%;
    width: 88%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 5px;
  }
  .arial-exhibitor-logo.arial-exhibitor-logo5 {
    position: absolute;
    height: 66%;
    width: 88%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 5px;
  }
}

@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  .ariel-booths {
    top: 125px;
  }
  .ariel-single-booth {
    height: 83px;
    width: 162px;
  }
  .arial-exhibitor-logo {
    height: 81px;
    width: 130px;
    top: -9px;
    left: 50%;
  }
  .arial-exhibitor-logo2 {
    height: 81px;
    width: 130px;
    top: -9px;
    left: 50%;
  }
  .arial-exhibitor-logo3 {
    height: 75px;
    width: 130px;
    top: -9px;
    left: 50%;
  }
  .arial-exhibitor-logo4 {
    height: 75px;
    width: 130px;
    top: -9px;
    left: 50%;
  }
  .arial-exhibitor-logo2.arial-exhibitor-logo5 {
    height: 75px;
    width: 130px;
    top: -9px;
    left: 50%;
  }
  .ariel-booths ul:first-child {
    margin-right: 35px;
  }
  .ariel-booths ul:nth-child(3) {
    margin-left: 25px;
  }
  .ariel-booths ul:nth-child(4) {
    margin-right: 38px;
    margin-left: 49px;
  }
}

@media only screen and (max-width: 1366px) {
  .ariel-booths {
    top: 125px;
  }
  .ariel-single-booth {
    height: 85px;
    width: 158px;
  }
  .arial-exhibitor-logo {
    height: 72px;
    width: 116px;
    top: -5px;
    left: 50%;
  }
  .arial-exhibitor-logo2 {
    height: 72px;
    width: 116px;
    top: -5px;
    left: 50%;
  }
  .arial-exhibitor-logo3 {
    height: 72px;
    width: 116px;
    top: -5px;
    left: 50%;
  }
  .arial-exhibitor-logo4 {
    height: 72px;
    width: 116px;
    top: -5px;
    left: 50%;
  }
  .arial-exhibitor-logo.arial-exhibitor-logo5 {
    height: 72px;
    width: 116px;
    top: -5px;
    left: 50%;
  }
  .ariel-booths ul:first-child {
    transform: skew(-15deg);
     margin-right: 1px;
  }
  .ariel-booths ul:first-child li {
    transform: skew(15deg);
  }
  .ariel-booths ul:nth-child(3) {
    margin-left: 16px;
  
  }
  .ariel-booths ul:nth-child(4) {
    margin-right: 27px;
    margin-left: 46px;
  }
  .ariel-booths ul:nth-child(5){
        transform: skew(16deg);
  }
  .ariel-booths ul:nth-child(5) li {
    transform: skew(-17deg);
  }
}
@media screen and ( max-width:767px ) {
  .pl-80{padding-left: 0; padding-right: 0;}
  .expoarielview-wrap {display: none;}
  .ariel-booths {top: 0; background: #333; height: 100%; width: 100%; position: relative; flex-direction: row;flex-wrap: wrap; align-items: center;padding: 100px 0 30px;}
  .ariel-booths ul{transform: none !important; margin:0 10px 20px 10px !important;}
  .ariel-booths ul:last-child{transform: none !important;}
  .ariel-booths ul li{transform: none !important; margin:0 0 15px 0  !important;}
  .ariel-booths ul:last-child li{transform: none !important; margin:0 0 15px 0  !important;}
  .ariel-single-booth img {display: none;}
  .arial-exhibitor-logo img {display: block;}
}
</style>
<script>
import jQuery from "jquery";
import db from "../components/firebaseInit";
import router from "../router";
import store from "../store";
let $ = jQuery;
export default {
  data() {
    return {
      Exhibitorlist: [],
      exhibitorTotalCount: 0,
      startRange: 0,
      endRange: 36,
      indexRow1: [30, 24, 18, 12, 6, 0],
      indexRow2: [31, 25, 19, 13, 7, 1],
      indexRow3: [32, 26, 20, 14, 8, 2],
      indexRow4: [33, 27, 21, 15, 9, 3],
      indexRow5: [34, 28, 22, 16, 10, 4],
      indexRow6: [35, 29, 23, 17, 11, 5],
      firstBoothDetails: [],
      secondBoothDetails: [],
      thirdBoothDetails: [],
      fourthBoothDetails: [],
      fifthBoothDetails: [],
      sixthBoothDetails: [],
      toolTipDetails: [],
      mouseCursorFlg: false,
      maxBoothIncrease: false,
      increaseVal: 0
    };
  },
  methods: {
    loadView(id) {
      store.commit("addExhibitorID", id);
      router.push({ name: "ExhibitorsView" });
    },
    closetooltip: function (val) {
      $("#" + val).hide();
    },
    getExhibitorList() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docref = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .orderBy("DisplaySequence", "asc")
        .where("IsPublished", "==", true);
      docref
        .get()
        .then((querySnapshot) => {
          this.exhibitorTotalCount = querySnapshot.size;
          if(this.exhibitorTotalCount > 36 && this.exhibitorTotalCount < 72){
            this.increaseVal = 36;
          }else if(this.exhibitorTotalCount > 72 && this.exhibitorTotalCount < 108){
            this.increaseVal = 72;
          }
          var id = "";
          querySnapshot.forEach((doc) => {
            id += doc.id + ",";
            store.commit("addExbList", id.substring(0, id.length - 1));
            this.Exhibitorlist.push(doc.data());
          });
          this.buildingBooth(this.Exhibitorlist);
        })
        .catch((error) => {
          alert(error);
        });
    },
    buildingBooth(data){
          this.indexRow1.map((row1) => {
            if (data[row1]) {
              this.firstBoothDetails.push(data[row1]);
            } else {
              this.firstBoothDetails.push({});
            }
          });

          this.indexRow2.map((row2) => {
            if (data[row2]) {
              this.secondBoothDetails.push(data[row2]);
            } else {
              this.secondBoothDetails.push({});
            }
          });


          this.indexRow3.map((row3) => {
            if (data[row3]) {
              this.thirdBoothDetails.push(data[row3]);
            } else {
              this.thirdBoothDetails.push({});
            }
          });


          this.indexRow4.map((row4) => {
            if (data[row4]) {
              this.fourthBoothDetails.push(data[row4]);
            } else {
              this.fourthBoothDetails.push({});
            }
          });


          this.indexRow5.map((row5) => {
            if (data[row5]) {
              this.fifthBoothDetails.push(data[row5]);
            } else {
              this.fifthBoothDetails.push({});
            }
          });


          this.indexRow6.map((row6) => {
            if (data[row6]) {
              this.sixthBoothDetails.push(data[row6]);
            } else {
              this.sixthBoothDetails.push({});
            }
          });

    },
    showtooltip: function (data) {
      store.commit("addExhibitorID", data.ExhibitorId);
      router.push({ name: "ExhibitorsView" });
    },
    getPrvLot: function () {
      this.startRange = parseInt(this.startRange) - 36;
      if (this.startRange <= 0) {
        this.startRange = 0;
      }

      this.endRange = parseInt(this.endRange) - 36;
      if (this.endRange >= this.exhibitorTotalCount) {
        this.endRange = this.exhibitorTotalCount;
      }
      if (this.endRange % 36 !== 0) {
        this.endRange = parseInt(this.endRange) + (36 - (this.endRange % 36));
      }

      this.indexRow1 = [30, 24, 18, 12, 6, 0];
      this.indexRow2 = [31, 25, 19, 13, 7, 1];
      this.indexRow3 = [32, 26, 20, 14, 8, 2];
      this.indexRow4 = [33, 27, 21, 15, 9, 3];
      this.indexRow5 = [34, 28, 22, 16, 10, 4];
      this.indexRow6 = [35, 29, 23, 17, 11, 5];

       this.firstBoothDetails = [];
       this.secondBoothDetails = [];
        this.thirdBoothDetails = [];
        this.fourthBoothDetails = [];
        this.fifthBoothDetails = [];
         this.sixthBoothDetails = [];
        this.buildingBooth(this.Exhibitorlist);
    },
    getNextLot: function () {
      this.startRange = parseInt(this.startRange) + 36;

      this.endRange = parseInt(this.endRange) + 36;
      if (this.endRange > this.exhibitorTotalCount) {
        this.endRange = this.exhibitorTotalCount;
      }


      this.indexRow1 = [30 + this.increaseVal, 24 + this.increaseVal, 18 + this.increaseVal, 12 + this.increaseVal, 6 + this.increaseVal, 0 + this.increaseVal];
      this.indexRow2 = [31 + this.increaseVal, 25 + this.increaseVal, 19 + this.increaseVal, 13 + this.increaseVal, 7 + this.increaseVal, 1 + this.increaseVal];
      this.indexRow3 = [32 + this.increaseVal, 26 + this.increaseVal, 20 + this.increaseVal, 14 + this.increaseVal, 8 + this.increaseVal, 2 + this.increaseVal];
      this.indexRow4 = [33 + this.increaseVal, 27 + this.increaseVal, 21 + this.increaseVal, 15 + this.increaseVal, 9 + this.increaseVal, 3 + this.increaseVal];
      this.indexRow5 = [34 + this.increaseVal, 28 + this.increaseVal, 22 + this.increaseVal, 16 + this.increaseVal, 10 + this.increaseVal, 4 + this.increaseVal];
      this.indexRow6 = [35 + this.increaseVal, 29 + this.increaseVal, 23 + this.increaseVal, 17 + this.increaseVal, 11 + this.increaseVal, 5 + this.increaseVal];

       this.firstBoothDetails = [];
       this.secondBoothDetails = [];
        this.thirdBoothDetails = [];
        this.fourthBoothDetails = [];
        this.fifthBoothDetails = [];
         this.sixthBoothDetails = [];
        this.buildingBooth(this.Exhibitorlist);
    },
  },
  mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
     if(obj.IsMouseCursorEnabled == true){
          this.mouseCursorFlg = true;
      }else{
        this.mouseCursorFlg = false;
        
      }
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    $("#topmenu").show();
    this.getExhibitorList();
  },
};
</script>

<style scoped>
@import "../assets/expo.css";
@import "../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";
</style>